export default "__VITE_ASSET__fdccbccc__"